<template>
  <el-dialog
    class="poster-modal"
    modal
    :visible="visible"
    title="设置视频封面"
    :close-on-click-modal="false"
    :width="modalWidth"
    @update:visible="handleVisibleUpdate"
    @closed="cancelFn"
    append-to-body
  >
    <div
      class="preview-poster-modal__content"
      :class="{
        'preview-poster-modal__content--editing': displayCoverIndex > -1
      }"
    >
      <div v-show="!captureShow">
        <div class="poster-title">设置视频封面图</div>
        <el-radio-group
          v-model="posterRadio"
          size="small"
          @change="radioChange"
          class="poster-cover-radio"
        >
          <el-radio-button label="crop">截取封面</el-radio-button>
          <el-radio-button label="upload">上传封面</el-radio-button>
        </el-radio-group>
      </div>
      <p class="preview-modal__tips" v-show="!captureShow">
        <el-checkbox
          class="fr"
          v-show="posterRadio === 'upload'"
          :disabled="!stampUsed"
          v-model="useStamp"
        >
          使用水印
        </el-checkbox>
        {{ posterTooltip }}
      </p>
      <div class="preview-modal__bg">
        <div class="preview-modal__video" v-if="posterRadio == 'crop'">
          <div
            class="poster-modal__content"
            :style="{ width: screenRatio * 480 + 'px' }"
          >
            <!-- video here -->
            <video :src="videoUrl" class="upload-video" ref="video" />
          </div>
          <div class="poster-modal__controls">
            <el-button
              circle
              type="primary"
              class="poster-modal__button"
              @click="togglePlay"
              size="small"
            >
              <icon-component
                :name="playing ? 'pause' : 'caret-right'"
                width="14"
                height="14"
              />
            </el-button>
            <el-slider
              class="poster-modal__slider"
              v-model="current"
              :min="0"
              :max="duration"
              :formatTooltip="formatTooltip"
              :disabled="playing"
            />
          </div>
        </div>
        <div class="poster-modal__content flex" v-loading="uploadLoding" v-else>
          <input
            type="file"
            @change="onInputChange"
            ref="uploadInput"
            class="input-upload"
            accept="image/*"
          />
          <div class="upload-box" v-if="uploadUrl">
            <div
              class="upload-img"
              :style="{
                width: screenRatio * 480 + 'px',
                backgroundImage: `url(${uploadUrl})`
              }"
            />
            <!-- <el-button
              class="upload-btn"
              type="primary"
              plain
              @click="onUploadButtonClick"
            >
              重新选择
            </el-button> -->
            <div class="close-box">
              <i class="el-icon-error" @click="clearUploadUrl"></i>
            </div>
          </div>
          <el-button
            style="position: relative; z-index: 3"
            v-else
            type="primary"
            plain
            @click="onUploadButtonClick"
          >
            选择文件
          </el-button>
        </div>
        <cover-selector
          :visible="visible"
          :readonly="captureShow"
          :activeIndex.sync="displayCoverIndex"
          :width="screenRatio * 480 + 'px'"
          :screenHeight="screenHeight"
          :screenRatio="screenRatio"
          :coverParams="coverParams"
          :fontList="fontList"
          :fontStates="fontStates"
          :hasStamp="hasStamp"
          :watermark="watermark"
        />
      </div>
    </div>
    <slot name="share" />
    <slot />
    <div class="cover-actions" v-show="!captureShow">
      <div class="cover-actions__text">
        <h4 class="cover-actions__heading">YouTube 风格封面</h4>
        <el-switch class="cover-actions__switch" v-model="presetCoverShowing" />
        <span class="cover-actions__help">
          好的封面能够吸引更多用户视线，可点击使用预设的常用 YouTube 封面样式。
        </span>
      </div>
      <el-popover v-model="iconVisible" popper-class="sticker-popover">
        <div class="sticker-overlay" v-loading="stickerLoading">
          <div class="sticker-overlay__title">
            添加贴纸
            <el-select
              class="sticker-overlay__select"
              v-model="activeStickerCategory"
              size="mini"
            >
              <el-option
                v-for="item in stickerCategories"
                :key="item.id"
                :value="item.id"
                :label="item.cn_name"
              />
            </el-select>
          </div>
          <div
            class="sticker-overlay__body"
            ref="scroll"
            @scroll="handleStickerScroll"
          >
            <div
              class="sticker-overlay__item"
              v-for="item in stickerList"
              :key="item.id"
            >
              <div
                class="sticker-overlay__display"
                :style="stickerStyle(item)"
                @click="addCoverSticker(item)"
              />
            </div>
          </div>
        </div>
        <el-button
          slot="reference"
          class="add-cover-text-btn"
          icon="el-icon-lollipop"
          size="mini"
        >
          添加贴纸
        </el-button>
      </el-popover>
      <el-button
        @click="addCoverText"
        class="add-cover-text-btn"
        icon="iconfont icon-text-border"
        size="mini"
      >
        添加文本
      </el-button>
    </div>
    <div
      class="poster-cover-scroll"
      v-show="presetCoverShowing && !captureShow"
    >
      <div class="poster-cover-scroll__list">
        <div
          v-for="(cover, i) in presetCovers"
          class="poster-cover-preview"
          :key="i"
          :style="{ backgroundImage: `url(${cover.thumbnail})` }"
          @click="addPresetCover(cover.params)"
        />
      </div>
    </div>
    <span slot="footer">
      <el-button size="small" @click="handleVisibleUpdate(false)">
        取消
      </el-button>
      <el-button size="small" @click="cancelFn" v-if="captureShow">
        编辑封面
      </el-button>
      <el-button
        v-if="captureShow"
        size="small"
        type="primary"
        @click="saveVideoPoster"
        :loading="loading"
      >
        确认生成
      </el-button>
      <el-button
        v-else
        size="small"
        type="primary"
        @click="capture"
        :disabled="posterRadio === 'upload' && !uploadUrl"
        :loading="loading"
      >
        {{ posterRadio === "upload" ? "使用" : "截取" }}
      </el-button>
    </span>
    <div
      class="preview-poster-modal__loading"
      :class="{ 'preview-poster-modal__loading--hidden': !loading }"
    >
      <i class="el-icon-loading" />
    </div>
  </el-dialog>
</template>
<script>
import { PauseOutline, CaretRightOutline } from '@ant-design/icons';
import { get, getSVGData, uploadFile } from '../../utils/api';
import CoverSelector from './CoverSelector';
import presetCovers from '../coverEditor/presetCovers';
import { encodeURIIfNeeded, getImageAspectRatio, getVideoAspectRatio } from '../../utils';
import { detectFont } from '../../series/seriesUtils';
import { normalizeSVGSource } from '../../utils/util';

const IconComponent = {
  props: ['name'],
  render() {
    const component = {
      pause: PauseOutline,
      'caret-right': CaretRightOutline
    }[this.name].icon;
    const renderComponent = (component) => this.$createElement(
      component.tag,
      { attrs: component.attrs },
      component.children ? component.children.map(renderComponent) : []
    );
    return renderComponent(component);
  }
};

export default {
  components: {
    'icon-component': IconComponent,
    CoverSelector
  },
  props: ['visible', 'videoUrl', 'fontList', 'coverParams', 'watermark', 'defaultCurrent', 'defaultType', 'defaultUrl', 'defaultChecked'],
  data() {
    return {
      playing: false,
      current: 0,
      posterRadio: 'crop',
      uploadUrl: '',
      uploadLoding: false,
      captureShow: false,
      captureCurrent: 0,
      activeCoverIndex: -1,

      screenRatio: 1.5,
      screenHeight: 720,
      duration: 5e3,
      presetCoverShowing: true,
      presetCovers,
      iconVisible: false,
      stickerList: [],
      stickerCategories: [],
      activeStickerCategory: '',
      currentPage: 1,
      totalPages: 1,
      stickerLoading: false,
      loading: false,
      fontStates: {},
      useStamp: false
    };
  },
  computed: {
    zoomRatio() {
      return this.screenHeight / 480;
    },
    modalWidth() {
      return this.displayCoverIndex > -1 ? '1178px' : '901px';
    },
    displayCoverIndex: {
      get() {
        return this.captureShow ? -1 : this.activeCoverIndex;
      },
      set(value) {
        this.activeCoverIndex = value;
      }
    },
    posterTooltip() {
      switch (this.posterRadio) {
        case 'crop':
          return '截取视频帧作为封面图，只需拖动以下预览视频到您想要的某一位置即可';
        case 'upload':
          return '支持 jpg, jpeg, png 格式，大小不超过 1M';
        default:
          return this.posterRadio;
      }
    },
    displayStickerCategory() {
      return this.iconVisible && this.activeStickerCategory;
    },
    selectedEffect() {
      return this.coverParams && this.coverParams[this.displayCoverIndex] || null;
    },
    currentFont() {
      return this.selectedEffect && this.selectedEffect.fontFamily;
    },
    stampUsed() {
      const { is_watermark, img } = this.watermark;
      return this.posterRadio === 'upload' && is_watermark && img.file;
    },
    hasStamp() {
      return this.stampUsed && this.useStamp;
    }
  },
  methods: {
    handleVisibleUpdate(e) {
      this.$emit('update:visible', e);
    },
    formatTooltip(value) {
      return (value / 1e3).toFixed(3) + "s";
    },
    processPlay() {
      let currentProgress = new Date() - this.start + this.prevProgress;
      if (currentProgress < this.duration) {
        this.current = currentProgress;
        this.playTimeout = requestAnimationFrame(this.processPlay); // TODO: play video if needed
      } else {
        this.playing = false;
        this.current = 0;
      }
    },
    togglePlay() {
      if (!this.playing) {
        this.playing = true;
        this.start = +new Date();
        this.prevProgress = this.current;
        this.playTimeout = requestAnimationFrame(this.processPlay);
      } else {
        this.pause();
      }
    },
    pause() {
      this.playing = false;
      cancelAnimationFrame(this.playTimeout);
      this.playTimeout = null;
    },
    // tab栏切换
    radioChange() {
      this.captureShow = false;
      if (this.playing) {
        this.pause();
      }
      this.$nextTick(() => {
        this.current = this.defaultCurrent;
        this.syncProgress();
      });
    },
    // 点击截取事件
    capture() {
      this.captureCurrent = this.current;
      this.captureShow = true;
    },
    // 保存视频封面并提交
    async saveVideoPoster() {
      let ms_cover, thumbnail, thumbnailSize, file;
      if (this.posterRadio == 'crop') {
        ms_cover = this.current;
      } else {
        thumbnail = this.uploadUrl;
        await getImageAspectRatio(thumbnail, img => {
          thumbnailSize = [img.naturalWidth, img.naturalHeight];
        });
      }
      // TODO: submit poster image
      /**
       * @type{HTMLCanvasElement}
       */
      const canvas = document.querySelector('canvas[data-cover-player-canvas]');
      if (canvas && (this.coverParams.length || this.hasStamp)) {
        let pending = {};
        let errors = false;
        this.loading = true;
        this.coverParams.forEach(cp => {
          if (!cp.type && cp.text && cp.fontFamily) {
            switch (this.fontStates[cp.fontFamily]) {
              case 'error':
                errors = true;
                break;
              case '':
                pending[cp.fontFamily] = detectFont(cp.fontFamily);
                break;
            }
          }
        });

        try {
          await Promise.all(Object.keys(pending).map(k => pending[k]));
        } catch (e) {
          errors = true;
        }
        if (errors) {
          this.$message.error('部分字体加载异常，可能无法正确生成封面。');
        }
        file = await new Promise(resolve => {
          canvas.toBlob(resolve, 'image/png');
        });
      }

      this.$emit('submit', {
        ms_cover,
        thumbnail,
        thumbnailSize,
        file,
        params: this.coverParams,
        hasStamp: this.hasStamp
      });
    },
    cancelFn() {
      this.$emit('cancel');
      this.captureShow = false;
      this.modalWidth = '901px';
    },
    async onInputChange(files) {
      console.log(files)
      this.uploadLoding = true
      const fn = ({ loaded, total }) => {
        console.log(loaded, total)
      };
      try {
        const res = await uploadFile([files], fn);
        this.uploadUrl = res.url || ''
      } catch (e) {
        // TODO:
        this.$message.error(e);
      }
      this.uploadLoding = false
      // this.$refs.uploadInput.value = ''
    },
    onUploadButtonClick() {
      console.log('material-show')
      this.$emit('material-show', 'showMaterial')
      // this.$refs.uploadInput.click();
    },
    clearUploadUrl() {
      this.uploadUrl = ''
      // this.$refs.uploadInput.value = ''
    },
    addCoverText() {
      // TODO:
      const len = this.coverParams.length;
      this.coverParams.push({
        text: 'Text',
        top: 0,
        left: 0,
        width: 200,
        height: 58,
        rotate: 0,
        opacity: 100,
        fontSize: 40,
        fontFamily: 'Montserrat-Bold',
        autoFontSize: true,
        color: '#333',
        useShadow: false,
        shadow: {
          x: 0,
          y: 3,
          blur: 8,
          color: 'rgba(0,0,0,.3)'
        },
        align: 'center',
        lineHeight: 1.4,
        stroke: '#49e',
        strokeWidth: 0,
        verticalAlign: 'middle'
      });
      this.activeCoverIndex = len;
    },
    async addCoverSticker(item) {
      const len = this.coverParams.length;
      const resp = await getSVGData(item.thumbnail);
      const { aspectRatio, source } = normalizeSVGSource(resp.data);

      this.coverParams.push({
        type: 'sticker',
        top: 0,
        left: 0,
        width: 120,
        height: 120 / aspectRatio,
        rotate: 0,
        opacity: 100,
        useShadow: false,
        shadow: {
          x: 0,
          y: 3,
          blur: 8,
          color: 'rgba(0,0,0,.3)'
        },
        stickerHTML: source
      });
      this.activeCoverIndex = len;
      this.iconVisible = false;
    },
    syncProgress() {
      if (this.videoUrl && !this.playing && this.$refs.video) {
        this.$refs.video.currentTime = this.current / 1e3;
      }
    },
    handleKeyDown(e) {
      if (
        !/input|textarea/i.test(e.target.tagName)
        && this.visible
      ) {
        switch (e.keyCode) {
          case 32:
            if (!/button/i.test(e.target.tagName) && this.posterRadio === 'crop') {
              this.togglePlay();
            }
            break;
          case 46:
          case 8:
            if (this.displayCoverIndex > -1) {
              e.preventDefault();
              const ef = this.selectedEffect;
              const isSticker = ef && ef.type;
              this.$confirm(
                isSticker ? '请确认是否删除该贴纸，删除后将无法撤销。' : '请确认是否删除该文字，删除后将无法撤销。',
                '提示',
                { type: 'warning' }
              ).then(() => {
                this.coverParams.splice(this.activeCoverIndex, 1);
                this.activeCoverIndex = -1;
                this.$message.success(isSticker ? '封面贴纸已移除。' : '封面文字已移除。');
              }, () => { });
            }
            break;
        }
      }
    },
    addPresetCover(cover) {
      const len = this.coverParams.length;
      this.coverParams.push.apply(this.coverParams, [].concat(JSON.parse(JSON.stringify(cover))));
      this.activeCoverIndex = len;
    },
    stickerStyle(item) {
      const url = item.thumbnail;
      return {
        backgroundImage: `url(${encodeURIIfNeeded(url)})`,
      };
    },
    async notifyDetectFont(font) {
      const { fontStates } = this;
      let timer, loading;

      try {
        if (fontStates[font]) {
          if (fontStates[font] === 'error') {
            throw new Error('font loading error');
          }
          return;
        }
        timer = setTimeout(() => {
          timer = null;
          loading = true;
          this.loading = true;
        }, 300);
        await detectFont(font);
        fontStates[font] = 'done';
      } catch (e) {
        fontStates[font] = 'error';
        this.$message.error('字体加载错误: ' + font);
      }
      if (timer) {
        clearTimeout(timer);
      } else if (loading) {
        this.loading = false;
      }
    },
    async getStickerList() {
      this.stickerLoading = true;
      const page = this.currentPage;
      const { data, totalPage } = await get('assembly/lists', {
        type: 2,
        page,
        limit: 60,
        classify: this.activeStickerCategory
      });
      this.stickerLoading = false;
      this.stickerList = (page === 1 ? [] : this.stickerList).concat(data);
      this.totalPages = totalPage;
    },
    handleStickerScroll(e) {
      if (this.currentPage < this.totalPages) {
        const el = e.target;
        if (!this.stickerLoading && el.scrollTop + el.clientHeight >= el.scrollHeight - 30) {
          this.currentPage++;
          this.getStickerList();
        }
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.current = this.defaultCurrent;
        this.posterRadio = this.defaultType || 'crop';
        this.uploadUrl = this.defaultUrl;
        this.useStamp = this.defaultChecked;
      } else {
        this.pause();
      }
    },
    async videoUrl(val) {
      if (val) {
        const aspectRatio = await getVideoAspectRatio(val, (video) => {
          this.duration = video.duration * 1e3;
          this.screenHeight = video.videoHeight;
        });
        this.screenRatio = aspectRatio;

        this.syncProgress();
      }
    },
    playing(cur, prev) {
      if (this.videoUrl) {
        if (cur && !prev) {
          this.$refs.video.play();
        } else if (!cur && prev) {
          this.$refs.video.pause();
          this.$nextTick(this.syncProgress);
        }
      }
    },
    current() {
      this.syncProgress();
    },
    defaultUrl() {
      this.uploadUrl = this.defaultUrl;
    },
    displayStickerCategory() {
      if (this.iconVisible) {
        setTimeout(() => {
          const { scroll } = this.$refs;
          scroll.scrollTop = 0;
        }, 0);
        this.currentPage = 1;
        this.totalPages = 1;
        this.getStickerList();
      } else {
        setTimeout(() => {
          this.activeStickerCategory = '';
          // reset category when hidden
        }, 300);
      }
    },
    fontList(val) {
      let states = Object.assign({}, this.fontStates);
      if (val) {
        val.forEach(t => {
          states[t.font_name] = states[t.font_name] || '';
        });
      }

      this.fontStates = states;
    },
    currentFont(val) {
      if (val) {
        this.notifyDetectFont(val);
      }
    }
  },
  async mounted() {
    document.body.addEventListener('keydown', this.handleKeyDown);
    const resp = await get('assembly/category', { type: 2 });
    this.stickerCategories = [
      { id: '', cn_name: '全部分类' }
    ].concat(resp);
  },
  beforeDestroy() {
    document.body.removeEventListener('keydown', this.handleKeyDown);
  }
}
</script>

<style scoped>
.poster-modal {
  text-align: center;
  white-space: nowrap;
}
.poster-modal:before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  white-space: normal;
}
.poster-modal ::v-deep .el-dialog {
  transition: 0.2s;
  margin-top: 0 !important;
  margin-bottom: 0;
  display: inline-block;
  vertical-align: middle;
  text-align: left;
}

.preview-modal__tips {
  font-size: 14px;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 14px;
}
.preview-modal__bg {
  position: relative;
}
.preview-modal__video {
  width: 100%;
  position: relative;
  background-color: #fff;
}
.preview-poster-modal__content {
  width: 100%;
  height: auto;
  position: relative;
}
.preview-poster-modal__content--editing {
  padding-right: 277px;
}
.poster-title {
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  left: 0;
  top: 5px;
  color: #17182f;
}
.poster-cover-radio ::v-deep .el-radio-button,
.poster-cover-radio ::v-deep .el-radio-button__inner {
  width: 250px;
}
.poster-cover-radio ::v-deep .is-active .el-radio-button__inner {
  color: #409eff;
  background-color: #fff;
  border: 1px solid #409eff;
  box-shadow: none;
}
.poster-modal__content {
  position: relative;
  overflow: hidden;
  background-color: #fff;
  margin: auto;
  height: 480px;
}
.poster-modal__content.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
.poster-modal__controls {
  display: flex;
  align-items: center;
  background: linear-gradient(
    to bottom,
    transparent,
    rgba(0, 0, 0, 0.05) 12%,
    rgba(0, 0, 0, 0.8)
  );
  border-top: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 0;
  padding: 20px 16px 12px;
  z-index: 3;
}
.poster-modal ::v-deep .el-dialog__body {
  position: relative;
  height: auto;
  text-align: center;
  overflow: hidden;
  background: #f7f8f9;
  word-break: normal;
  padding: 18px 24px;
}

/* .poster-modal ::v-deep .el-dialog__footer {
  display: flex;
  align-items: center;
  background: linear-gradient(
    to bottom,
    transparent,
    rgba(0, 0, 0, 0.05) 12%,
    rgba(0, 0, 0, 0.8)
  );
  border-top: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 0;
  padding-top: 20px;
  z-index: 3;
} */

.poster-modal__button {
  line-height: 1;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.poster-modal__button .anticon {
  transition: 0s;
}

.poster-modal__button .anticon-caret-right {
  margin-left: 1px;
}

.poster-modal__button svg {
  display: block;
  width: 14px;
  height: 14px;
  fill: currentColor;
}

.poster-modal__slider {
  margin: 0 12px;
  padding: 7px 0;
  height: 16px;
  flex-grow: 1;
}

.poster-modal__slider ::v-deep .el-slider__runway {
  margin: 0;
  background: rgba(255, 255, 255, 0.35);
}

.poster-modal__slider ::v-deep .el-slider__runway:before {
  content: "";
  position: absolute;
  top: -7px;
  left: 0;
  right: 0;
  bottom: -7px;
}

.poster-modal__slider ::v-deep .el-slider__runway,
.poster-modal__slider ::v-deep .el-slider__bar {
  height: 4px;
}

.poster-modal__slider ::v-deep .el-slider__bar {
  background: #fff;
}

.poster-modal__slider ::v-deep .disabled .el-slider__bar {
  background: rgba(255, 255, 255, 0.5);
}

.poster-modal__slider ::v-deep .el-slider__button-wrapper {
  top: -17px;
}

.poster-modal__slider ::v-deep .el-slider__button {
  width: 14px;
  height: 14px;
  border: 0;
}
.input-upload {
  display: none;
}
.upload-img,
.upload-video {
  position: absolute;
  right: 0;
  height: 100%;
  top: 0;
  left: 0;
}

.upload-img {
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin: 0 auto;
}
.upload-btn {
  width: 98px;
  height: 40px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 3;
}
.upload-box {
  width: 100%;
  height: 100%;
  position: relative;
}
.close-box {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 999;
  text-align: center;
  padding: 5px 20px;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 0 0 0 10px;
  display: none;
}
.el-icon-error {
  font-size: 28px;
  cursor: pointer;
  color: #fff;
}

.preview-poster-modal__content:hover .upload-btn,
.preview-poster-modal__content:hover .upload-box .close-box {
  display: block;
}
.preview-modal__review {
  width: 256.8px;
  height: 220px;
  position: relative;
  margin-left: 20px;
  flex-shrink: 0;
}
.preview-modal__review_btns {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 20px;
  display: flex;
  justify-content: space-around;
}
.preview-modal__review .preview-modal__review_box {
  width: 850px;
  height: calc((9 / 16) * 850px);
  transform: scale(0.3);
  transform-origin: 0 0;
}
.preview-modal__review .preview-modal__review_box.active {
  position: fixed;
  transform: scale(1.51);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  transform-origin: 50% 50%;
  z-index: 999;
  background-color: rgba(128, 128, 128, 0.8);
  padding: 26px 0;
  box-sizing: unset;
  overflow: hidden;
}
.preview-modal__review .preview-modal__review_box .player-box {
  position: relative;
  height: 100%;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 998;
}

.cover-actions {
  padding: 12px 0 0;
  margin-bottom: -6px;
  text-align: left;
  display: flex;
  align-items: center;
}

.cover-actions__text {
  display: flex;
  flex-grow: 1;
  align-items: center;
}

.cover-actions__heading {
  font-weight: 700;
  margin: 0;
  font-size: 100%;
}

.cover-actions__switch {
  margin: 0 12px 0 8px;
  /* min-width: 36px;
  height: 18px; */
}

/* .cover-actions__switch:after {
  width: 14px;
  height: 14px;
} */

.cover-actions__switch:not(.ant-switch-disabled):active:after,
.cover-actions__switch:not(.ant-switch-disabled):active:before {
  width: 20px;
}

.cover-actions__help {
  font-size: 12px;
}

.add-cover-text-btn {
  padding: 6px 12px;
  margin-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-cover-text-btn ::v-deep .iconfont,
.add-cover-text-btn ::v-deep .el-icon-lollipop {
  color: #007eff;
  margin-right: 6px;
  font-size: 14px;
}

.add-cover-text-btn ::v-deep .el-icon-lollipop + span {
  margin: 0;
}

.poster-cover-scroll {
  overflow-x: auto;
  margin: 18px 0 -6px;
}

.poster-cover-scroll::-webkit-scrollbar {
  width: 16px;
  height: 16px;
}

.poster-cover-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.poster-cover-scroll::-webkit-scrollbar-thumb {
  border: 4px solid transparent;
  background-color: rgba(0, 0, 0, 0.2);
  background-clip: content-box;
  border-radius: 8px;
}

.poster-cover-scroll::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.25);
}

.poster-cover-scroll::-webkit-scrollbar-corner {
  background: transparent;
}

.poster-cover-scroll__list {
  display: flex;
}

.poster-cover-preview {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  width: 200px;
  height: 110px;
  margin-right: 10px;
  flex-shrink: 0;
  transition: 0.2s;
}

.poster-cover-preview:hover {
  box-shadow: inset 0 0 0 2px #007eff;
}

.sticker-overlay {
  height: 320px;
  display: flex;
  flex-direction: column;
}

.sticker-overlay__title {
  height: 56px;
  border-bottom: 1px solid #e4e4e4;
  display: flex;
  align-items: center;
  padding: 12px 16px;
}

.sticker-overlay__select {
  width: 100px;
  margin-left: 8px;
}

/* .sticker-overlay__select ::v-deep .ant-select-selection {
  height: 25px;
  font-size: 12px;
  border-radius: 2px;
}

.sticker-overlay__select ::v-deep .ant-select-selection__rendered {
  line-height: 23px;
} */

.sticker-overlay__body {
  flex-grow: 1;
  padding: 12px;
  overflow: auto;
  background: #f7f8f9;
  display: flex;
  flex-wrap: wrap;
}

.sticker-overlay__item {
  width: 20%;
  border: 5px solid transparent;
  position: relative;
}

.sticker-overlay__item:before {
  content: "";
  display: block;
  background: #fff
    url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCAyIDIiPjxwYXRoIGQ9Ik0wIDBMMCAxTDIgMUwyIDJMMSAyTDEgMHoiIGZpbGw9InJnYmEoMCwwLDAsLjIpIi8+PC9zdmc+);
  background-size: 12px;
  padding-bottom: 100%;
}

.sticker-overlay__display {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  transition: 0.2s;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.preview-poster-modal__loading {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.6);
  z-index: 99;
  transition: 0.3s;
}

.preview-poster-modal__loading--hidden {
  visibility: hidden;
  opacity: 0;
}

.preview-poster-modal__loading .el-icon-loading {
  position: absolute;
  font-size: 32px;
  top: 50%;
  left: 50%;
  margin: -16px;
  color: #1890ff;
}
</style>
<style>
.el-popover.sticker-popover {
  width: 440px;
  max-height: none;
  padding: 0;
}
</style>